import React, { memo } from 'react';
// mui
import { Grid } from '@mui/material';
// components
import ActionButton from 'components/buttons';
// styles
import { getStyles } from '../../modals/styles';

interface IProps {
  backLabel: string;
  nextLabel: string;
  handleBack: () => void;
  loading?: boolean;
  disableSubmit?: boolean;
}

const styles = getStyles();

const ActionButtons: React.FC<IProps> = ({
  backLabel,
  nextLabel,
  handleBack,
  loading,
  disableSubmit,
}) => {
  return (
    <Grid sx={styles.actions}>
      <ActionButton
        type="button"
        onClick={handleBack}
        label={backLabel}
        variant="secondary"
        disabled={loading}
      />

      <ActionButton label={nextLabel} type="submit" loading={loading} disabled={disableSubmit} />
    </Grid>
  );
};

export default memo(ActionButtons);
